import { ref, Ref } from 'vue'

type ClickCallback = (...args: any[]) => void

export function useClickLock(delay = 1000): {
  disabled: Ref<boolean>
  lock: (callback?: ClickCallback) => void
} {
  const disabled = ref<boolean>(false)

  const lock = (callback?: ClickCallback): void => {
    if (disabled.value) return

    disabled.value = true

    try {
      if (callback) {
        callback()
      }
    } finally {
      setTimeout(() => {
        disabled.value = false
      }, delay)
    }
  }

  return {
    disabled,
    lock
  }
}
